@if (content()?.items.length > 0) {
  <div [ngClass]="content().subjectTaxonomyTags">
    <div [ngClass]="{ 'grid-col-12 grid-max-width no-row-gap': useGrid() }">
      <div class="col-1-12 md-col-2-11">
        <div [class]="sectionWrapperClass()">
          @if (!disableTeaserTitle() && content().teaserTitle !== '') {
            <h2 data-testid="collection-teaser-title" [ngClass]="content().subjectTaxonomyTags">
              {{ content().teaserTitle }}
            </h2>
          }
          <div [ngClass]="{ 'grid-col-12 grid-max-width no-row-gap no-gutters': useGrid() }">
            @for (item of content().items; track $index) {
              <div [class]="sectionClass()">
                @if (item.contentType === CmsContentType.CMVideo) {
                  <fin-video
                    [ngClass]="'white-text text-icon-reversed ' + content().subjectTaxonomyTags.join(' ')"
                    [videoTitle]="item.teaserTitle"
                    [videoUrl]="item.dataUrl"
                    [showPopup]="item.viewType === CmsViewType.POPUP"
                    [noMargin]="true"
                  />
                }

                @if (item.contentType === CmsContentType.CMPicture) {
                  @if (item.picture) {
                    <div
                      data-testid="collection-image"
                      class="image-wrapper relative flex radius-medium overflow-hidden"
                    >
                      <fin-content-image
                        [imageData$]="item.picture | finToObservable"
                        [aspectRatio$]="aspectRatio() | finToObservable"
                      />
                    </div>
                  }
                }

                @if (item.contentType === CmsContentType.CMArticle) {
                  <cms-rich-text
                    [attr.data-testid]="'item-teaser-title-' + item.contentId"
                    [extraClasses]="'font-body-small mr-small-b ' + item.subjectTaxonomyTags.join(' ')"
                    [headerLevel]="content().teaserTitle !== '' ? 3 : 2"
                    [headerStyles]="content().teaserTitle !== '' ? [] : ['font-headline-small']"
                    [scaleImage]="false"
                    [content]="articles().get(item.contentId)"
                  />
                }

                @if (item.related?.length) {
                  @for (link of item.related; track $index) {
                    <div class="flex flex--start font-body-medium-bold">
                      <a
                        [finLink]="link.target.url"
                        [external]="link.target.external"
                        [attr.target]="link.target.openInNewTab ? '_blank' : ''"
                        [ngClass]="link.subjectTaxonomyTags"
                        class="descriptive-link no-decoration flex flex--center"
                        ><span class="pr-xxsmall-r" data-testid="collection-teaser-link-title">{{
                          link.teaserTitle
                        }}</span
                        ><fcom-icon
                          class="icon-medium"
                          [ngClass]="link.subjectTaxonomyTags"
                          [name]="SvgLibraryIcon.ARROW_RIGHT"
                      /></a>
                    </div>
                  }
                }

                @if (item?.customTemplate) {
                  <ng-container [ngTemplateOutlet]="item?.customTemplate" />
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
